import { Component, OnInit } from '@angular/core';

declare var Razorpay: any;

@Component({
  selector: 'app-payment-checkout',
  templateUrl: './payment-checkout.component.html',
  styleUrls: ['./payment-checkout.component.scss']
})
export class PaymentCheckoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  payNow() {
    const RozarpayOptions = {
      description: 'Sample Razorpay Demo',
      currency: 'INR',
      amount: 59000, // Amount in paise (50000 paise = INR 500)
      name: 'Aditya Dubey',
      key: 'rzp_test_10WZRp9xtxbJy9',
      image: 'https://img.freepik.com/free-vector/safe-secure-einr-erupi-digital-currency-symbol-design_1017-49290.jpg?t=st=1734007024~exp=1734010624~hmac=9964b7ad672577b2a102802a17a510f7f5772b9f6158b21ec31b843678fa9d8f&w=740',
      prefill: { // Corrected spelling: "prefill" instead of "prefills"
        name: 'Aditya Dubey',
        email: 'aditya.dubey@nirjai.com',
        phone: '8429892895',
      },
      theme: {
        color: '#6466e3',
      },
      modal: {
        ondismiss: () => {
          console.log('Payment modal dismissed');
        },
      },
      handler: (response: any) => {
        // This function will be triggered on successful payment
        console.log('Payment Success:', response);
        // The response contains:
        // - razorpay_payment_id: Payment ID
        // - razorpay_order_id: Order ID (if created)
        // - razorpay_signature: Signature for validation
      },
    };

    const rzp = new Razorpay(RozarpayOptions);

    rzp.on('payment.failed', (response: any) => {
      // This will be triggered on payment failure
      console.error('Payment Failure:', response);
      // The response contains:
      // - code: Failure code
      // - description: Reason for failure
      // - source: Source of failure (e.g., payment gateway, customer)
      // - step: At which step the failure occurred
      // - reason: Failure reason
      // - metadata: Additional information
    });

    rzp.open();
  }

}
